import { prisma, SMS as SMSTemplate, ResourceType, ActionType } from "client";

// CREATE
export const createSMSTemplate = async (userId: string, data: SMSTemplate) => {
  try {
        const template = await prisma.sMS.create({
      data: {
        message: data.message,
        notificationTemplate: {
          connect: { id: data.notificationTemplateId },
        },
      },
    });
    return { template };
  } catch (error) {
    return { error };
  }
};

// READ
export const getAllSMSTemplates = async (
  userId: string
): Promise<{
  templates?: SMSTemplate[];
  error?: any;
}> => {
  try {
        const templates = await prisma.sMS.findMany();
    return { templates };
  } catch (error) {
    return { error };
  }
};

export const getAllSMSTemplatesDataWithNotificationTemplateData = async (
  userId: string
) => {
  try {
        const templates = await prisma.sMS.findMany();
    const withNotification: any[] = [];

    for (let template of templates) {
      const notificationTemplate = await prisma.notificationTemplate.findUnique(
        {
          where: { id: template.notificationTemplateId },
        }
      );
      withNotification.push({
        ...template,
        notificationTemplate,
      });
    }

    return { templates: withNotification };
  } catch (error) {
    return { error };
  }
};

export const getSMSTemplateById = async (id: string) => {
  return await prisma.sMS.findUnique({
    where: { id },
  });
};

export const getSMSTemplateBynotificationTemplateId = async (
  notificationTemplateId: string
) => {
  try {
    const SMSTemplate = await prisma.sMS.findUnique({
      where: { notificationTemplateId },
    });
    return { SMSTemplate };
  } catch (error) {
    return { error };
  }
};

// UPDATE
export const updateSMSTemplateById = async (
  userId: string,
  id: string,
  data: SMSTemplate
) => {
  try {
        return await prisma.sMS.update({
      where: { id },
      data: {
        message: data.message,
        notificationTemplate: { connect: { id: data.notificationTemplateId } },
      },
    });
  } catch (error: any) {
    console.error(error);
    throw new Error(error.message);
  }
};

// DELETE
export const deleteSMSTemplateById = async (userId: string, id: string) => {
  try {
        return await prisma.sMS.delete({
      where: { id },
    });
  } catch (error: any) {
    console.error(error);
    throw new Error(error.message);
  }
};
